<ng-container *ngIf="icon">
  <ng-container [ngSwitch]="icon.type">
    <mat-icon class="icons-mat-icon" *ngSwitchCase="'maticon'">{{icon.name}}</mat-icon>
    <mat-icon class="icons-svg" *ngSwitchCase="'svg'" svgIcon="{{icon.name}}"></mat-icon>
    <i class="icons-fontawesome" *ngSwitchCase="'fontawesome'" [ngClass]="icon.name"></i>
    <mat-icon *NgSwitchDefault>explore</mat-icon>
  </ng-container>
</ng-container>
